import { fork, all } from 'redux-saga/effects';
import { watchAuth } from '../auth';
import { watchPermission } from '../permissions';
import { watchRole } from '../role';
import { watchAdmin } from '../admin';
import { watchFundingSource } from '../fundingSource';
import { watchClient } from '../client';
import { watchSystem } from '../system';
import { watchNotes } from '../notes';
import { watchComments } from '../comments';
import { watchAiNote } from '../aiNote';
import { watchAiTransform } from '../aiTransform';
import { watchPayroll } from '../payroll';
import { watchAvailabilitySchedule } from '../availabilitySchedule';
import { watchAppointments } from '../appointment';
import { watchClaim, watchInvoice, watchInvoiceTxn } from '../billing';
import { watchClaimPayment, watchInvoicePayment } from '../posting';
import { watchHistory } from '../history';
import { watchReports } from '../reports';
import { watchStaffPayroll } from '../staffPayroll';
import { watchNotification } from '../notification';
import { watchAnalytics } from '../analytics';
import { watchDashboard } from '../dashboard';
import { watchTags } from '../tags';
import { watchForm } from '../form';
import { watchResource } from '../resource';
import {
    watchAbc,
    watchAssessment,
    watchDomains,
    watchEvents,
    watchGoals,
    watchSessions,
    watchBaselines,
    watchProgressReports,
    watchClinicalAnalytics,
} from '../clinical';
import { watchLibrary } from '../library';
import { watchFiles } from '../file';
import { watchChat } from '../chat';
import { watchSupervision } from '../supervision';
import { watchPostedNote } from '../postedNote';
import { watchVersions } from '../versions';
import { watchTutorialVideos } from '../tutorialVideos';
import { watchClientDiagnosis } from '../clientDiagnosis';
import { watchWishlist } from '../wishlist';
import { watchDocumentVersion } from '../documentVersion';
import { watchTasks } from '../tasks';
import { watchMap } from '../map';
import { watchUserPreferences } from '../userPreferences';
import { watchSignatureRequest } from '../signatureRequest';

// /** Combined Sagas */
// export const appSaga = function* startForman() {
//     yield fork(watchAuth);
//     yield fork(watchAdmin);
//     yield fork(watchRole);
//     yield fork(watchPermission);
//     yield fork(watchFundingSource);
//     yield fork(watchClient);
//     yield fork(watchSystem);
//     yield fork(watchNotes);
//     yield fork(watchPayroll);
//     yield fork(watchAvailabilitySchedule);
//     yield fork(watchAppointments);
//     yield fork(watchClaim);
//     yield fork(watchInvoice);
//     yield fork(watchClaimPayment);
//     yield fork(watchInvoicePayment);
//     yield fork(watchHistory);
//     yield fork(watchReports);
//     yield fork(watchStaffPayroll);
//     yield fork(watchNotification);
//     yield fork(watchAnalytics);
//     yield fork(watchTags);
// };

export const appSaga = function* rootSaga() {
    yield all([
        fork(watchAuth),
        fork(watchAdmin),
        fork(watchRole),
        fork(watchPermission),
        fork(watchFundingSource),
        fork(watchClient),
        fork(watchSystem),
        fork(watchNotes),
        fork(watchComments),
        fork(watchAiNote),
        fork(watchAiTransform),
        fork(watchPayroll),
        fork(watchAvailabilitySchedule),
        fork(watchAppointments),
        fork(watchClaim),
        fork(watchInvoice),
        fork(watchInvoiceTxn),
        fork(watchClaimPayment),
        fork(watchInvoicePayment),
        fork(watchHistory),
        fork(watchReports),
        fork(watchStaffPayroll),
        fork(watchNotification),
        fork(watchAnalytics),
        fork(watchDashboard),
        fork(watchTags),
        fork(watchMap),
        fork(watchForm),
        fork(watchResource),
        /** Clinical */
        fork(watchGoals),
        fork(watchDomains),
        fork(watchAssessment),
        fork(watchAbc),
        fork(watchSessions),
        fork(watchEvents),
        fork(watchBaselines),
        fork(watchProgressReports),
        fork(watchClinicalAnalytics),
        fork(watchLibrary),
        fork(watchFiles),
        fork(watchChat),
        fork(watchSupervision),
        fork(watchPostedNote),
        fork(watchTasks),
        fork(watchVersions),
        fork(watchTutorialVideos),
        fork(watchClientDiagnosis),
        fork(watchWishlist),
        fork(watchDocumentVersion),
        fork(watchUserPreferences),
        fork(watchSignatureRequest),
        /** End */
    ]);
};
